var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftKnowCarouselArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  transform: "matrix(-1 0 0 1 36 .705)",
  fill: "#000",
  fillOpacity: 0.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  transform: "matrix(-1 0 0 1 35 .705)",
  stroke: "#fff",
  strokeOpacity: 0.72
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.833 18.705H12.167m0 0L18 12.872m-5.833 5.833L18 24.538",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgLeftKnowCarouselArrow;